// ABOUTME: The closed set of valid theme names and their MUI theme objects.
// ABOUTME: Source of truth for which themes exist on the frontend; backend validates against the same names.
import type { Theme } from '@mui/material/styles';
import defaultTheme from './theme';
import altTheme from './theme.alt';
import naluV1Theme from './theme.nalu-v1';

export const themeRegistry = {
  default: defaultTheme,
  alt: altTheme,
  'nalu-v1': naluV1Theme,
} satisfies Record<string, Theme>;

export type ThemeName = keyof typeof themeRegistry;

export function isValidThemeName(name: string | undefined | null): name is ThemeName {
  return !!name && name in themeRegistry;
}

export function resolveTheme(effectiveThemeName: string | undefined): Theme {
  return isValidThemeName(effectiveThemeName) ? themeRegistry[effectiveThemeName] : defaultTheme;
}
